module.exports = __webpack_public_path__ + "static/media/Slave-Rebellion-1019-LEDE.0eded6d1.jpg";